import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import { IAppointmentCustomer } from '../../../../../types'

import {
  AppointmentCustomerLabel,
  AppointmentCustomerLink,
  CurrentCustomerWrapper,
} from './style'

interface IProps {
  customerDetails: IAppointmentCustomer
}

export const AppointmentCustomer: FunctionComponent<IProps> = ({
  customerDetails,
}) => {
  const { t } = useTranslation()

  const navigateToCustomer = (): void => {
    window.open(
      `${process.env.REACT_APP_CLIENT_URL}/customers/${customerDetails.id}`,
    )
  }
  return (
    <CurrentCustomerWrapper>
      <AppointmentCustomerLabel>
        {`${t('Current customer')}:`}
      </AppointmentCustomerLabel>
      <AppointmentCustomerLink onClick={navigateToCustomer}>
        {`${customerDetails.firstName} ${customerDetails.lastName}`}
      </AppointmentCustomerLink>
    </CurrentCustomerWrapper>
  )
}
